import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getAmenitiesListLoading: false,
  getAmenitiesListFailed: false,
  getAmenitiesListReject: false,
  getAmenitiesListMessage: [],
  AmenitiesList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_AMENITIES_LIST_LOADING: {
      return {
        ...state,
        getAmenitiesListLoading: true,
        getAmenitiesListFailed: false,
        getAmenitiesListReject: false,
        getAmenitiesListMessage: [],
        AmenitiesList: [],
      };
    }
    case actionTypes.GET_AMENITIES_LIST_SUCCESS: {
      return {
        ...state,
        getAmenitiesListLoading: false,
        getAmenitiesListFailed: false,
        getAmenitiesListReject: false,
        getAmenitiesListMessage: [],
        AmenitiesList: action.payload,
      };
    }
    case actionTypes.GET_AMENITIES_LIST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getAmenitiesListLoading: false,
        getAmenitiesListFailed: true,
        getAmenitiesListReject: false,
        getAmenitiesListMessage: message,
        AmenitiesList: [],
      };
    }
    case actionTypes.GET_AMENITIES_LIST_REJECT: {
      return {
        ...state,
        getAmenitiesListLoading: false,
        getAmenitiesListFailed: false,
        getAmenitiesListReject: true,
        getAmenitiesListMessage: [],
        AmenitiesList: [],
      };
    }

    default:
      return state;
  }
};
